// @flow

import React from 'react';
import { Link } from 'react-router';

import Feature from '../util/Feature';

import CollectionTracks from '../messages/CollectionTracks';
import CollectionRecordings from '../messages/CollectionRecordings';
import CollectionPlaylists from '../messages/CollectionPlaylists';
import CollectionAlbums from '../messages/CollectionAlbums';
import CollectionArtists from '../messages/CollectionArtists';
import CollectionLivestreamEvents from '../messages/CollectionLivestreamEvents';

type CollectionLinksProps = {
  linkClassName: string,
  onClick: () => void,
};

const CollectionLinks = (props: CollectionLinksProps) => (
  <ul>
    <li>
      <Link
        to="/collection/tracks"
        className={props.linkClassName}
        activeClassName="is-active"
        onClick={props.onClick}
        data-test="collection-link.tracks"
      >
        <CollectionTracks />
      </Link>
    </li>
    <li>
      <Link
        to="/collection/recordings"
        className={props.linkClassName}
        activeClassName="is-active"
        onClick={props.onClick}
        data-test="collection-link.recordings"
      >
        <CollectionRecordings />
      </Link>
    </li>
    <li>
      <Feature id="user_playlists">
        {allowed => {
          return (
            <Link
              to={allowed ? '/collection/playlists/personal' : 'collection/playlists'}
              className={props.linkClassName}
              activeClassName="is-active"
              onClick={props.onClick}
              data-test="collection-link.playlists"
            >
              <CollectionPlaylists />
            </Link>
          );
        }}
      </Feature>
    </li>
    <li>
      <Link
        to="/collection/albums"
        className={props.linkClassName}
        activeClassName="is-active"
        onClick={props.onClick}
        data-test="collection-link.albums"
      >
        <CollectionAlbums />
      </Link>
    </li>
    <li>
      <Link
        to="/collection/artists"
        className={props.linkClassName}
        activeClassName="is-active"
        onClick={props.onClick}
        data-test="collection-link.artists"
      >
        <CollectionArtists />
      </Link>
    </li>
    <li>
      <Link
        to="/collection/events"
        className={props.linkClassName}
        activeClassName="is-active"
        onClick={props.onClick}
        data-test="collection-link.events"
      >
        <CollectionLivestreamEvents />
      </Link>
    </li>
  </ul>
);

export default CollectionLinks;
